import { useEffect } from 'react';
import { notificationsSelectors } from 'redux/modules/Notifications';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { getDiscountRequestNotificationsThunk } from 'redux/modules/Notifications/notifications.thunk';
import { setNotificationList } from 'redux/modules/Notifications/notifications';
import { NotificationType, UserRole } from 'interfaces';
import { useCheckRoles } from 'hooks';
import { NotificationCard } from './components';
import * as S from './NotificationList.styles';

export const NotificationList = () => {
  const dispatch = useAppDispatch();

  const notificationList = useAppSelector(
    notificationsSelectors.getNotificationList,
  );

  const isForUser = useCheckRoles(UserRole.User);
  const isForAnyMod = useCheckRoles(
    UserRole.Mod,
    UserRole.Super,
    UserRole.Admin,
  );

  useEffect(() => {
    if (!isForUser && !isForAnyMod) {
      return undefined;
    }

    dispatch(
      getDiscountRequestNotificationsThunk(
        isForUser
          ? [NotificationType.STATUS_CHANGED]
          : [
              NotificationType.ASSIGNED_TO_YOU,
              NotificationType.ASSIGNED_TO_ANOTHER,
            ],
      ),
    );

    return () => {
      dispatch(setNotificationList(null));
    };
  }, []);

  return (
    <S.Container>
      {notificationList?.map((n) => (
        <NotificationCard notification={n} key={n.id} />
      ))}
    </S.Container>
  );
};
